<template>
	<div class="width_100">
		<naviBack type='list1' title="订单列表" background="#ffffff" />
		<div>order</div>
	</div>
</template>

<script>
	import {
		datePrintStr,isPhone
	} from "../lib/utils"
	import naviBack from '../components/navi_back.vue';
	import {
		getVenueServiceDetail
	} from '../api/api.js'
	export default {
		components: {
			naviBack
		},
		name: "",
		data() {
			return {
				
			};
		},
		mounted() {
			
		},
		methods: {
			
		},
	};
</script>

<style lang="less" scoped="scoped">
	@vm_base: 1/750 * 100vw;
	
</style>


// WEBPACK FOOTER //
// src/views/order_list.vue